import React, {useEffect, useState} from 'react'
import ReactDOM from 'react-dom'
import {useImageViewerData} from '@state/image-viewer-data'

const ImageViewer = () => {
  var windowScrollPosition = window.pageYOffset
  const imageViewerData = useImageViewerData(state => state.imageViewerData)
  const {isOpen, viewIndex, images, overflow} = imageViewerData
  const [state, setState] = useState({
    viewingIndex: undefined,
    isImageLoading: true,
  })
  const onSetImageViewerData = useImageViewerData(state => state.onSetImageViewerData)

  useEffect(() => {
    if (isOpen && images?.length > 0) setState({...state, viewingIndex: viewIndex})
    windowScrollPosition = window.pageYOffset
  }, [isOpen])

  const onToggleClose = () => {
    setState({isImageLoading: false, viewingIndex: undefined})
    setTimeout(() => window.scrollTo(0, windowScrollPosition), 0)
    onSetImageViewerData({})
  }

  const handleViewIndexChange = viewingIndex => {
    setState({isImageLoading: true, viewingIndex})
  }

  if (!isOpen || images?.length === 0 || state.viewingIndex === undefined) return null

  return ReactDOM.createPortal(
    <div className="modal is-active" style={{zIndex: 9999}}>
      <div className="modal-background tw:bg-dark-gray" style={{opacity: 0.95}} />
      <div
        className="modal-content tw:flex is-justify-content-center"
        style={{width: '90%', maxHeight: '90%', overflow: overflow || 'hidden'}}
      >
        <div className="tw:flex is-align-items-center	is-justify-content-space-between" style={{width: '100%'}}>
          <button
            type="button"
            disabled={state.viewingIndex === 0}
            className="button tw:text-primary is-rounded tw:px-3"
            onClick={() => handleViewIndexChange(state.viewingIndex - 1)}
          >
            <i className="fa-2x fa-light fa-angle-left" />
          </button>

          <figure
            className="image tw:mx-4"
            style={{width: '35%', margin: 'auto', display: 'grid', placeItems: 'center'}}
          >
            {state.isImageLoading && (
              <p className="icon is-large tw:text-white">
                <i className="fa-3x fa-solid fa-spinner fa-spin" />
              </p>
            )}

            <img
              className={`${state.isImageLoading ? 'is-hidden' : ''}`}
              src={
                images[state.viewingIndex]?.url ||
                `${import.meta.env.VITE_CDN_URI}/static/dashboard-service/image-404.jpg`
              }
              onLoad={() => setState({...state, isImageLoading: false})}
            />
          </figure>

          <button
            type="button"
            disabled={state.viewingIndex === images.length - 1}
            className="button tw:text-primary is-rounded tw:px-3"
            onClick={() => handleViewIndexChange(state.viewingIndex + 1)}
          >
            <i className="fa-2x fa-light fa-angle-right" />
          </button>
        </div>
      </div>
      <a href="#" className="modal-close is-large" onClick={onToggleClose}>
        <span className="icon tw:text-black">
          <i className="fa-light fa-times-circle" />
        </span>
      </a>
    </div>,
    document.body
  )
}

export default ImageViewer
